export const DEFAULT_INTERNAL_TRANSFER_FEE_PIPS = 1;

export function buildEmptyInternalTransferSettingsForm() {
  return {
    feePips: String(DEFAULT_INTERNAL_TRANSFER_FEE_PIPS),
  };
}
